/**
 * Reveal — IntersectionObserver-Reveal als Ersatz für AOS
 *
 * Targets: alle Elemente mit [data-aos], [data-reveal]
 *
 * Verhalten:
 *  - Element ist initially opacity-0 + translate-y-2 (via CSS)
 *  - bei Intersection: opacity-100 + translate-y-0
 *  - prefers-reduced-motion: sofort sichtbar, keine Transition
 *  - Nur einmal pro Element (kein retrigger)
 */

const SELECTOR = "[data-aos], [data-reveal]";

let observer = null;

function reveal(element) {
  element.classList.add("is-revealed");
  element.removeAttribute("data-aos");
  element.removeAttribute("data-reveal");
}

export function init() {
  const targets = document.querySelectorAll(SELECTOR);
  if (targets.length === 0) return;

  // Mark all targets as pending (CSS hides them until revealed)
  targets.forEach((target) => target.setAttribute("data-revealing", ""));

  if (
    typeof IntersectionObserver === "undefined" ||
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    targets.forEach(reveal);
    return;
  }

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px -10% 0px" }
  );

  targets.forEach((target) => observer.observe(target));
}
